import React from 'react';
import { IMAGES } from '../data';
import { Reveal } from './Reveal';
export function Philosophy() {
  return <section id="filosofi" className="w-full bg-warm py-28 md:py-40" data-id="element-126" data-mp="3dwvse2kn9f9c">
      {/* Varumärke — intro statement */}
      <div className="mx-auto max-w-4xl px-6 text-center md:px-10" data-id="element-127" data-mp="305r23r361zbo">
        <Reveal data-id="element-128" data-mp="3553knzn08k8g">
          <p className="mb-8 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-129" data-mp="354lkirx81lv9">Varumärke</p>
        </Reveal>
        <Reveal delay={0.1} data-id="element-130" data-mp="2q7kxh1pz6f34">
          <h2 className="font-display text-3xl font-light leading-tight text-brun sm:text-4xl md:text-5xl" data-id="element-131" data-mp="2qapcyv8w4x93">
            Smaken som Baken är inte en vanlig cateringplattform. Det är en noggrant utvald
            samlingsplats för Smålands främsta matupplevelser.
          </h2>
        </Reveal>
        <Reveal delay={0.2} data-id="element-132" data-mp="2m8vfswxwmbdo">
          <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-brun-soft" data-id="element-133" data-mp="fgkx07hylvlx">
            Vi samlar verksamheter som delar samma syn på mat – där smak, kvalitet och hantverk
            alltid går före volym och pris. Här hittar du människor som bryr sig om råvaror,
            detaljer och upplevelsen runt bordet.
          </p>
        </Reveal>
        <Reveal delay={0.3} data-id="element-134" data-mp="139khaqvkj6hb">
          <p className="mt-10 font-display text-2xl italic text-skog md:text-3xl" data-id="element-135" data-mp="1h17nbifbbtda">
            Hos oss finns inte allt.
            <br data-id="element-136" data-mp="1c1mg6kpzoeph" />
            Bara det vi själva skulle servera.
          </p>
        </Reveal>
      </div>

      {/* Vår filosofi — image + copy */}
      <div className="mx-auto mt-28 grid max-w-7xl items-center gap-12 px-6 md:mt-40 md:grid-cols-2 md:gap-20 md:px-10" data-id="element-137" data-mp="octpb2o84x1q">
        <Reveal className="order-2 md:order-1" data-id="element-138" data-mp="kdb2208xk9vq">
          <p className="mb-6 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-139" data-mp="ybrdu5lngqkq">Vår filosofi</p>
          <h3 className="font-display text-3xl font-light leading-tight text-brun md:text-4xl" data-id="element-140" data-mp="talkc5k60za5">
            Vi tror att mat är mer än något man äter.
          </h3>
          <div className="mt-8 space-y-4 text-lg leading-relaxed text-brun-soft" data-id="element-141" data-mp="24r1yzwnwbbvy">
            <p data-id="element-142" data-mp="24t658l99omze">
              Den sätter stämningen på ett möte. Den samlar familj och vänner. Den gör ett bröllop
              minnesvärt. Den lyfter en konferens. Den får ett företagsevent att kännas genomtänkt.
              Den får gäster att stanna lite längre.
            </p>
            <p data-id="element-143" data-mp="2lq353uy4yddy">Det är därför vi väljer våra partners med omsorg.</p>
          </div>
          <p className="mt-8 font-display text-xl italic text-bourgogne md:text-2xl" data-id="element-144" data-mp="2qqqyuodr18bv">
            Hos Smaken som Baken hittar du inte det billigaste. Du hittar det bästa.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="order-1 md:order-2" data-id="element-145" data-mp="1y2v25jo6jgf3">
          <div className="grid grid-cols-5 gap-4" data-id="element-146" data-mp="231enpiyv2q6x">
            <div className="col-span-3 overflow-hidden rounded-sm" data-id="element-147" data-mp="22zlhu5w2o9zz">
              <img src={IMAGES.bakerSourdough} alt="Bagares mjöliga händer skär ett surdegsbröd" className="h-full w-full object-cover" data-id="element-148" data-mp="27t6hs3h87e1t" />
            </div>
            <div className="col-span-2 mt-10 overflow-hidden rounded-sm" data-id="element-149" data-mp="1fa9c5fzyek2f">
              <img src={IMAGES.coffeeSteam} alt="Ånga stiger från en kopp nybryggt kaffe" className="h-full w-full object-cover" data-id="element-150" data-mp="17r9sd98kyqij" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}